import { render } from "./ChangeLanguage.vue?vue&type=template&id=373bd2bc&scoped=true&ts=true"
import script from "./ChangeLanguage.vue?vue&type=script&lang=ts"
export * from "./ChangeLanguage.vue?vue&type=script&lang=ts"

import "./ChangeLanguage.vue?vue&type=style&index=0&id=373bd2bc&scoped=true&lang=css"

import exportComponent from "C:\\Users\\khale\\Cookies BIS\\Core-Abudari\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-373bd2bc"]])

export default __exports__